export enum ToastType {
  Success,
  Error,
}
